import { RoomIntegrationData } from "../../../../models/room";

interface RoomIntegrationDataDTO {
  _id: string;
  name: string;
  address: string;
  address2?: string;
  guestyLinkedRoom?: {
    _id?: string;
    nickname?: string;
    title?: string;
  };
  avantioLinkedRoom?: {
    id?: string;
    name?: string;
  };
  krossLinkedRoom?: {
    idProperty?: string;
    idRoom?: string;
    idRoomType?: string;
    number?: string;
    nameRoomType?: string;
    qtGuests?: string;
  };
  hostifyLinkedListing?: {
    id?: string;
    nickname?: string;
    address?: string;
    city?: string;
  };
  hostawayLinkedListing?: {
    listingId?: number;
    name?: string;
    address?: string;
    city?: string;
    countryCode?: string;
  };

  rentalreadyLinkedRental?: {
    rentalId?: string;
    name?: string;
    city?: string;
  };
  icneaLinkedProperty?: {
    lodgingId?: number;
    name?: string;
    address?: string;
    city?: string;
    country?: string;
  };
}

export const mapRoomsWithIntegrations = (room: RoomIntegrationDataDTO): RoomIntegrationData => {
  return {
    _id: room._id,
    name: room.name,
    address: room.address,
    address2: room.address2,
    guestyLinkedRoom: room.guestyLinkedRoom,
    avantioLinkedRoom: room.avantioLinkedRoom,
    krossLinkedRoom: room.krossLinkedRoom,
    hostifyLinkedListing: room.hostifyLinkedListing,
    hostawayLinkedListing: room.hostawayLinkedListing,
    rentalreadyLinkedRental: room.rentalreadyLinkedRental,
    icneaLinkedProperty: room.icneaLinkedProperty,
  };
};
